import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-5427">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-5428">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-5429">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-5430">
            <ArrowLeft className="w-4 h-4" data-id="element-5431" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-5432">NOIZA</div>
          <div className="w-20" data-id="element-5433" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-5434">
        <div className="mb-12" data-id="element-5435">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-5436">
            <FileText className="w-6 h-6 text-white/80" data-id="element-5437" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-5438">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-5439">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-5440">
          <section data-id="element-5441">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5442">
              <span className="text-[#006847]" data-id="element-5443">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5444">
              <p data-id="element-5445">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-5446">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5447">
                <li data-id="element-5448">Haber leído íntegramente este documento</li>
                <li data-id="element-5449">Comprender su contenido en su totalidad</li>
                <li data-id="element-5450">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-5451">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-5452">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5453">
              <span className="text-[#006847]" data-id="element-5454">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5455">
              <p data-id="element-5456">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5457">
                <li data-id="element-5458">Software como servicio (SaaS)</li>
                <li data-id="element-5459">Marketplace digital gastronómico</li>
                <li data-id="element-5460">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-5461">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5462">
                <li data-id="element-5463">Mostrar su menú digital</li>
                <li data-id="element-5464">Recibir pedidos de clientes</li>
                <li data-id="element-5465">Gestionar su operación interna</li>
                <li data-id="element-5466">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-5467">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-5468">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5469">
              <span className="text-[#006847]" data-id="element-5470">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5471">
              <p data-id="element-5472">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5473">
                <li data-id="element-5474">No es proveedor de alimentos</li>
                <li data-id="element-5475">No participa en la preparación de productos</li>
                <li data-id="element-5476">No manipula alimentos en ningún momento</li>
                <li data-id="element-5477">No realiza entregas ni logística</li>
                <li data-id="element-5478">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-5479">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-5480">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-5481">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5482">
              <span className="text-[#006847]" data-id="element-5483">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-5484">
              <p data-id="element-5485">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-5486">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5487">
                <li data-id="element-5488">El restaurante es el único responsable de su operación</li>
                <li data-id="element-5489">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-5490">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-5491">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5492">
                <li data-id="element-5493">Precios</li>
                <li data-id="element-5494">Menú</li>
                <li data-id="element-5495">Horarios</li>
                <li data-id="element-5496">Métodos de pago</li>
                <li data-id="element-5497">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5498">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5499">
              <span className="text-[#006847]" data-id="element-5500">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-5501">
              <div data-id="element-5502">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5503">
                  5.1. Alcance general
                </h3>
                <p data-id="element-5504">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-5505">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5506">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-5507">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5508">
                  <li data-id="element-5509">Calidad de los alimentos</li>
                  <li data-id="element-5510">Estado, frescura o preparación</li>
                  <li data-id="element-5511">Ingredientes utilizados</li>
                  <li data-id="element-5512">Contaminación cruzada</li>
                  <li data-id="element-5513">Problemas de higiene o salubridad</li>
                  <li data-id="element-5514">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5515">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-5516">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5517">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-5518">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5519">
                  <li data-id="element-5520">Retrasos en la entrega</li>
                  <li data-id="element-5521">Pérdida de pedidos</li>
                  <li data-id="element-5522">Entregas incompletas</li>
                  <li data-id="element-5523">Errores en dirección</li>
                  <li data-id="element-5524">Conducta de repartidores</li>
                  <li data-id="element-5525">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-5526">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5527">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-5528">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-5529">
                  <li data-id="element-5530">Recepción de pagos</li>
                  <li data-id="element-5531">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-5532">Manejo de efectivo</li>
                  <li data-id="element-5533">Confirmación de pagos</li>
                  <li data-id="element-5534">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-5535">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5536">
                  <li data-id="element-5537">Pagos no recibidos</li>
                  <li data-id="element-5538">Comprobantes falsos</li>
                  <li data-id="element-5539">Errores en montos</li>
                  <li data-id="element-5540">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-5541">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5542">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-5543">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5544">
                  <li data-id="element-5545">Reclamos de clientes</li>
                  <li data-id="element-5546">Reembolsos</li>
                  <li data-id="element-5547">Cancelaciones</li>
                  <li data-id="element-5548">Disputas</li>
                  <li data-id="element-5549">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5550">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-5551">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5552">
              <span className="text-[#006847]" data-id="element-5553">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-5554">
              <p data-id="element-5555">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5556">
                <li data-id="element-5557">Responsable</li>
                <li data-id="element-5558">Legal</li>
                <li data-id="element-5559">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-5560">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5561">
                <li data-id="element-5562">Publicar información falsa</li>
                <li data-id="element-5563">Manipular precios de forma engañosa</li>
                <li data-id="element-5564">Simular disponibilidad inexistente</li>
                <li data-id="element-5565">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5566">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5567">
              <span className="text-[#006847]" data-id="element-5568">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-5569">
              <p data-id="element-5570">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5571">
                <li data-id="element-5572">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-5573">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-5574">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5575">
                <li data-id="element-5576">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-5577">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-5578">
                    <li data-id="element-5579">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-5580">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-5581">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5582">
              <span className="text-[#006847]" data-id="element-5583">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-5584">
              <p data-id="element-5585">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5586">
                <li data-id="element-5587">Menú digital</li>
                <li data-id="element-5588">Gestión de pedidos</li>
                <li data-id="element-5589">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-5590">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5591">
                  <p className="font-medium text-white mb-2" data-id="element-5592">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5593">
                    <li data-id="element-5594">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5595">
                  <p className="font-medium text-white mb-2" data-id="element-5596">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5597">
                    <li data-id="element-5598">Propiedad del software</li>
                    <li data-id="element-5599">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-5600">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-5601">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5602">
              <span className="text-[#006847]" data-id="element-5603">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5604">
              <p data-id="element-5605">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5606">
                <li data-id="element-5607">Disponibilidad continua</li>
                <li data-id="element-5608">Funcionamiento sin interrupciones</li>
                <li data-id="element-5609">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-5610">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5611">
                <li data-id="element-5612">Fallas técnicas</li>
                <li data-id="element-5613">Actualizaciones</li>
                <li data-id="element-5614">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-5615">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-5616">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5617">
              <span className="text-[#006847]" data-id="element-5618">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-5619">
              <p data-id="element-5620">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5621">
                <li data-id="element-5622">No está garantizada permanentemente</li>
                <li data-id="element-5623">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-5624">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5625">
                <li data-id="element-5626">Destacar o no restaurantes</li>
                <li data-id="element-5627">Modificar posiciones</li>
                <li data-id="element-5628">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5629">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5630">
              <span className="text-[#006847]" data-id="element-5631">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-5632">
              <p data-id="element-5633">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5634">
                <li data-id="element-5635">Cumplir con los pagos acordados</li>
                <li data-id="element-5636">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-5637">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5638">
                <li data-id="element-5639">Suspender el servicio</li>
                <li data-id="element-5640">Limitar funcionalidades</li>
                <li data-id="element-5641">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5642">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5643">
              <span className="text-[#006847]" data-id="element-5644">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5645">
              <p data-id="element-5646">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5647">
                <li data-id="element-5648">Incumplimiento de términos</li>
                <li data-id="element-5649">Uso indebido</li>
                <li data-id="element-5650">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-5651">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-5652">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5653">
              <span className="text-[#006847]" data-id="element-5654">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-5655">
              <p data-id="element-5656">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-5657">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-5658">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5659">
              <span className="text-[#006847]" data-id="element-5660">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-5661">
              <p data-id="element-5662">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5663">
                <li data-id="element-5664">Pérdidas económicas</li>
                <li data-id="element-5665">Daños indirectos</li>
                <li data-id="element-5666">Lucro cesante</li>
                <li data-id="element-5667">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5668">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5669">
              <span className="text-[#006847]" data-id="element-5670">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-5671">
              <p data-id="element-5672">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-5673">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5674">
              <span className="text-[#006847]" data-id="element-5675">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-5676">
              <p className="font-medium" data-id="element-5677">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-5678">
                <li data-id="element-5679">Ha leído este documento completo</li>
                <li data-id="element-5680">Comprende su alcance</li>
                <li data-id="element-5681">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}